import React from 'react';
import { Eye } from 'lucide-react';

/**
 * Visual badge listing OTHER users currently viewing the resource.
 * Hidden when no one else is connected.
 */
export default function PresenceBadge({ others }) {
    if (!Array.isArray(others) || others.length === 0) return null;

    const initials = (name) =>
        (name || '?')
            .split(' ')
            .map((s) => s.trim()[0])
            .filter(Boolean)
            .slice(0, 2)
            .join('')
            .toUpperCase();

    const colors = [
        'bg-rose-500', 'bg-amber-500', 'bg-emerald-500',
        'bg-sky-500', 'bg-violet-500', 'bg-fuchsia-500',
    ];
    const colorFor = (uid) => colors[Math.abs(hash(uid)) % colors.length];

    const text =
        others.length === 1
            ? `${others[0].user_name} consulte cette fiche`
            : `${others.map((o) => o.user_name).join(', ')} consultent cette fiche`;

    return (
        <div
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-xs font-medium"
            data-testid="presence-badge"
            title={text}
        >
            <Eye className="w-3.5 h-3.5" />
            <div className="flex -space-x-1.5">
                {others.slice(0, 3).map((o) => (
                    <span
                        key={o.user_id}
                        className={`w-5 h-5 rounded-full ${colorFor(o.user_id)} text-white text-[9px] font-bold inline-flex items-center justify-center ring-2 ring-amber-50`}
                    >
                        {initials(o.user_name)}
                    </span>
                ))}
            </div>
            <span className="hidden sm:inline">{text}</span>
            <span className="sm:hidden">{others.length} en ligne</span>
        </div>
    );
}

function hash(s) {
    let h = 0;
    for (let i = 0; i < (s || '').length; i++) {
        h = ((h << 5) - h) + s.charCodeAt(i);
        h |= 0;
    }
    return h;
}
